// file: `react/src/components/MemberAvatars.tsx`:

import React from 'react';
import { Avatar, AvatarGroup } from '@chatscope/chat-ui-kit-react';
import { chatscopeAvatarSrc } from './chatscopeAvatar.ts';

export type Member = {
  id?: string;
  shortName?: string;
  fullName?: string;
  emoji?: string;
};

function statusOf(name: string | undefined, online: string[]) {
  if (!name) return 'unavailable';
  return online.includes(name) ? 'available' : 'unavailable';
}

export function memberLabel(member?: Member) {
  return member?.emoji || member?.shortName?.[0] || member?.fullName?.[0] || '?';
}

export function memberAvatarNode({
  members,
  online = [],
  size = 'sm',
  max = 3,
  fallback
}: {
  members?: Member[];
  online?: string[];
  size?: 'xs' | 'sm' | 'md' | 'lg';
  max?: number;
  fallback?: string;
}) {
  const list = Array.isArray(members) ? members.filter(Boolean) : [];
  if (list.length <= 1) {
    const member = list[0];
    return (
      <Avatar
        src={chatscopeAvatarSrc(member ? memberLabel(member) : (fallback || '?'))}
        name={member?.shortName || member?.fullName || fallback || 'Conversation'}
        size={size}
        status={member ? statusOf(member.shortName, online) : undefined}
      />
    );
  }
  return (
    <AvatarGroup max={max} size={size}>
      {list.map((member) => (
        <Avatar
          key={member.id || member.shortName}
          src={chatscopeAvatarSrc(memberLabel(member))}
          name={member.shortName || member.fullName}
          status={statusOf(member.shortName, online)}
        />
      ))}
    </AvatarGroup>
  );
}

export default function MemberAvatars(props) {
  return memberAvatarNode(props);
}
